// **********************************************************
// Main Services Slider Work
// **********************************************************
const mainServicesSlider = document.querySelectorAll('[data-slider="main-services-slider"]');
if (mainServicesSlider.length > 0) {
  let mainServicesSliderEle;

  // Product Main Slider
  const mainServicesSliderOptions = {
    slidesPerView: 'auto',
    spaceBetween: 16,
    speed: 600,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      767: {
        spaceBetween: 20,
      },
      1023: {
        allowTouchMove: false,
        spaceBetween: 0,
      },
    },
  };

  mainServicesSlider.forEach((el) => {
    const mainServicesSliderParent = el.closest('.main-services');
    const paginationElement = mainServicesSliderParent.querySelector('.swiper-pagination');
    mainServicesSliderOptions.pagination.el = paginationElement;

    if (windowWidth() >= breakpointMd) {
      mainServicesSliderOptions.effect = 'fade';
      mainServicesSliderOptions.fadeEffect = {
        crossFade: true,
      };
    }

    mainServicesSliderEle = new Swiper(el, mainServicesSliderOptions);
  });

  const closeAllAccordions = () => {
    const allAccordions = document.querySelectorAll('.main-services__accordion-item');
    allAccordions.forEach((accordion) => {
      accordion.classList.remove('is-open');
      closeAccordion(accordion.querySelector('.main-services__accordion-text'));
    });
  };

  // **********************************************************
  // Main Services Animations
  // **********************************************************

  const mainServices = document.querySelectorAll('.main-services');
  let controllerMainServices = null;
  controllerMainServices = new ScrollMagic.Controller();

  const initStickyElementScene = (element, parent, duration, startPoint, pagination, paginationBullet) => {
    const accordion = parent.querySelector('.main-services__accordion');
    const moveAccordion = new TimelineMax();

    moveAccordion.to(accordion, 1, { y: '-50%', ease: Power2.easeInOut });

    const stickyScene = new ScrollMagic.Scene({
      triggerElement: startPoint,
      duration: `${duration}%`,
      triggerHook: 0,
    })
      .on('enter', () => {
        toggleActiveClass(paginationBullet[0], true);
        pagination.classList.add('is-visible');
      })
      .on('leave', () => {
        pagination.classList.remove('is-visible');
      })
      .setPin(element)
      .setTween(moveAccordion)
      .addTo(controllerMainServices);

    if (isLocal()) {
      stickyScene.addIndicators({ name: 'Sticky' });
    }
  };

  const openAccordion = (element) => {
    gsap.to(element, { height: 'auto', duration: 0.3 });
  };

  const closeAccordion = (element) => {
    gsap.to(element, { height: '0', duration: 0.3 });
  };

  const toggleItems = (element, toggle, i) => {
    element[i].classList.toggle('is-open', toggle);
  };

  const initEachSlideScene = (fakeSlides, accordion, paginationBullet) => {
    fakeSlides.forEach((slideElem, i) => {
      new ScrollMagic.Scene({
        triggerElement: slideElem,
        duration: slideElem.clientHeight,
        triggerHook: 0,
      })
        .on('enter', (e) => {
          const content = accordion[i].querySelector('.main-services__accordion-text');

          if (e.scrollDirection === 'FORWARD' && i > 0) {
            toggleItems(accordion, true, i);
            openAccordion(content);
          }

          if (e.scrollDirection === 'REVERSE' && i < accordion.length - 1) {
            closeAllAccordions();
            toggleItems(accordion, true, i);
            openAccordion(content);
          }

          mainServicesSliderEle.slideTo(i, 800);
          toggleActiveClass(paginationBullet[i], true);
        })
        .on('leave', (e) => {
          const content = accordion[i].querySelector('.main-services__accordion-text');

          if (e.scrollDirection === 'FORWARD' && i < accordion.length - 1) {
            closeAllAccordions();
            toggleItems(accordion, false, i);
            closeAccordion(content);
          }

          if (e.scrollDirection === 'REVERSE' && i > 0) {
            toggleItems(accordion, false, i);
            closeAccordion(content);
          }

          mainServicesSliderEle.slideTo(i, 800);
          toggleActiveClass(paginationBullet[i], false);
        })
        // .addIndicators({ name: `slide ${i}` })
        .addTo(controllerMainServices);
    });
  };

  const initAllScenes = () => {
    mainServices.forEach((el) => {
      const parentElement = el.closest('.sc-main-services');
      const stickyElement = parentElement.querySelector('.main-services__body-inner');
      const fakeSlides = parentElement.querySelectorAll('.main-services__faker-slide');
      const fakeSlidesWrapper = parentElement.querySelector('.main-services__faker-slides');
      const startPoint = parentElement.querySelector('.main-services__animation-start');
      const accordion = parentElement.querySelectorAll('.main-services__accordion-item');
      const paginationBullet = parentElement.querySelectorAll('.main-services__pagination-item');
      const pagination = parentElement.querySelector('.main-services__pagination');

      initStickyElementScene(
        stickyElement,
        parentElement,
        `${fakeSlidesWrapper.clientHeight}px`,
        startPoint,
        pagination,
        paginationBullet,
      );
      initEachSlideScene(fakeSlides, accordion, paginationBullet);
    });
  };

  const handleResize = () => {
    initializeOrDestroyScrollMagic(controllerMainServices, initAllScenes);
  };

  if (windowWidth() >= breakpointMd) {
    initAllScenes();
  }

  window.addEventListener('resize', handleResize);

  const scrollToSlide = (element, scrollBehavior) => {
    const elementRect = element.getBoundingClientRect();
    const scrollTop = window.scrollY || window.pageYOffset || document.documentElement.scrollTop;
    const topOffset = elementRect.top + scrollTop + 20;
    window.scrollTo({
      top: topOffset,
      behavior: scrollBehavior,
    });
  };

  attachEvent('.main-services__accordion-title', 'click', (ev) => {
    const allAccordions = Array.from(document.querySelectorAll('.main-services__accordion-item'));
    const accordionItem = ev.target.closest('.main-services__accordion-item');
    const clickedIndex = allAccordions.indexOf(accordionItem);
    const parentElem = ev.target.closest('.main-services');
    const targetItem = parentElem.querySelector(`[data-slide="${clickedIndex + 1}"]`);
    scrollToSlide(targetItem, 'instant');
  });
}
